import { V004PartitionCharacter } from './V004AlgorithmTypes';
export function doesPayloadRequireSigning(payload) {
    return payload.shared_vault_uuid != undefined;
}
export function deconstructEncryptedPayloadString(payloadString) {
    var _a;
    /** Base64 encoding of JSON.stringify({}) */
    const EmptyAdditionalDataString = 'e30=';
    const components = payloadString.split(V004PartitionCharacter);
    return {
        version: components[0],
        nonce: components[1],
        ciphertext: components[2],
        authenticatedData: components[3],
        additionalData: (_a = components[4]) !== null && _a !== void 0 ? _a : EmptyAdditionalDataString,
    };
}
